module.exports = __webpack_public_path__ + "img/icon_group_1@2x.52cdd09c.png";